import { UntypedFormGroup } from "@angular/forms";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { IProduktdefinition, IProduktinstruktion } from "./IProduktdefinition";
import { ProduktdefinitionFargmarkningdata } from "./ProduktdefinitionFargmarkningdata";
import { ProduktdefinitionFordelningsmatrisdata } from "./ProduktdefinitionFordelningsmatrisdata";
import { ProduktdefinitionGrunddata } from "./ProduktdefinitionGrunddata";
import { ProduktdefinitionHeaderData } from "./ProduktdefinitionHeaderData";
import { ProduktdefinitionMatrisdata } from "./ProduktdefinitionMatrisdata";
import { IProduktdefinitionBasdata } from "./ProduktdefinitionModels";
import { ProduktdefinitionRestriktioner } from "./ProduktdefinitionRestriktioner";
import { ProduktdefinitionStolpdata } from "./ProduktdefinitionStolpdata";
import { ProduktdefinitionVardematrisdata } from "./ProduktdefinitionVardematrisdata";

export class ProduktdefinitionViewModel {
    produktinstruktionAktiv: boolean;
    headerData: ProduktdefinitionHeaderData;
    grunddata: ProduktdefinitionGrunddata;
    canEdit: boolean;
    restriktioner: ProduktdefinitionRestriktioner;
    stolpdata: ProduktdefinitionStolpdata;
    vardematris: ProduktdefinitionVardematrisdata;
    fargmarkning: ProduktdefinitionFargmarkningdata;
    fordelningsmatrisdata: ProduktdefinitionFordelningsmatrisdata;
    isMassEditering: boolean;
    isHistorisk: boolean;
    matrisdata: ProduktdefinitionMatrisdata;
    get isUtkast() {
        return !ObjectUtils.isNullOrUndefined(this.model.utkastProduktdefinition) && this.model.utkastProduktdefinition?.id === this.headerData.id;
    }

    get isNew() {
        return this.isUtkast && !this.model.utkastProduktdefinition?.id;
    }

    get version() {
        return this.headerData.version;
    }

    set version(value: string) {
        this.headerData.version = value;
    }

    get hasUtkast(): boolean {
        return !ObjectUtils.isNullOrUndefined(this.model.utkastProduktdefinition.id);
    }

    constructor(
        private readonly model: IProduktinstruktion,
        private readonly form: UntypedFormGroup,
        useUtkast: boolean,
        canEdit: boolean,
        private readonly basdata: IProduktdefinitionBasdata,
        isMassEditering = false,
        ovriga: ProduktdefinitionViewModel[] = []
    ) {
        this.produktinstruktionAktiv = model.aktiv;
        this.isMassEditering = isMassEditering;
        const produktdefinition = useUtkast ? model.utkastProduktdefinition : model.aktivProduktdefinition;
        this.canEdit = useUtkast && canEdit;
        this.setProduktdefinition(produktdefinition, basdata, form, ovriga);
        this.isHistorisk = false;
    }

    selectHistorik(produktdefinition: IProduktdefinition) {
        this.setProduktdefinition(produktdefinition, this.basdata, this.form, []);
        this.canEdit = false;
        this.isHistorisk = true;
    }

    getDto(): IProduktdefinition {
        this.headerData.mapToDto(this.model.utkastProduktdefinition);
        this.grunddata.mapToDto(this.model.utkastProduktdefinition);
        this.matrisdata.mapToDto(this.model.utkastProduktdefinition);
        this.restriktioner.mapToDto(this.model.utkastProduktdefinition);
        this.stolpdata.mapToDto(this.model.utkastProduktdefinition);
        this.fordelningsmatrisdata.mapToDto(this.model.utkastProduktdefinition);
        this.vardematris.mapToDto(this.model.utkastProduktdefinition);
        this.fargmarkning.mapToDto(this.model.utkastProduktdefinition);
        return this.model.utkastProduktdefinition;
    }

    private setProduktdefinition(produktdefinition: IProduktdefinition, basdata: IProduktdefinitionBasdata, form: UntypedFormGroup, ovriga: ProduktdefinitionViewModel[]) {
        this.headerData = new ProduktdefinitionHeaderData(produktdefinition, basdata);
        this.grunddata = new ProduktdefinitionGrunddata(produktdefinition);
        this.matrisdata = new ProduktdefinitionMatrisdata(produktdefinition, form, this.headerData, this.canEdit, () => {
            if (this.vardematris.radprisLangdkorrektion === "Procent") {
                return 100;
            }
            return 0;
        }, ovriga);
        this.stolpdata = new ProduktdefinitionStolpdata(produktdefinition, this.matrisdata);
        this.fordelningsmatrisdata = new ProduktdefinitionFordelningsmatrisdata(produktdefinition, this.matrisdata);
        this.fargmarkning = new ProduktdefinitionFargmarkningdata(this.matrisdata);
        this.vardematris = new ProduktdefinitionVardematrisdata(produktdefinition, this.matrisdata);
        this.restriktioner = new ProduktdefinitionRestriktioner(produktdefinition);
    }
}
